import { money } from "@/lib/api";

export const savingsPcts = (s) =>
  s?.savings_range ? [Number(s.savings_min_pct), Number(s.savings_max_pct)] : [Number(s?.savings_pct ?? 20), Number(s?.savings_pct ?? 20)];

const one = (price, lbs, fee, pct) => {
  const ourPrice = price * (1 - pct / 100);
  const perLb = price - ourPrice;
  const savings = lbs * perLb;
  return { ourPrice, perLb, totalNow: lbs * price, totalUs: lbs * ourPrice, savings, net: savings - fee, breakEven: Math.ceil(fee / perLb) };
};

export const compute = (price, lbs, fee, [lo, hi]) => ({ lo: one(price, lbs, fee, lo), hi: one(price, lbs, fee, hi), range: lo !== hi });

export const span = (r, key, fmt = money) => {
  const [a, b] = [r.lo[key], r.hi[key]].sort((x, y) => x - y);
  return a === b ? fmt(a) : `${fmt(a)} – ${fmt(b)}`;
};

export const pctLabel = ([lo, hi]) => (lo === hi ? `${lo}%` : `${lo}–${hi}%`);
